import { Injectable } from '@angular/core';
import { BaseFacade } from '../base/base.facade';
import { TranslateService } from '@ngx-translate/core';
import { PageService } from './page.service';
import { PageStore } from './page.store';
import { PageQuery } from './page.query';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { AppTokenService } from '../../../app-token.service';

@Injectable({ providedIn: 'root' })
export class PageFacade extends BaseFacade {

    constructor(
        private readonly pageService: PageService,
        pageStore: PageStore,
        pageQuery: PageQuery,
        dynamicSchemaFacto: DynamicSchemaFactory,
        translateService: TranslateService) {
        super(pageService,
          pageStore,
          pageQuery,
          dynamicSchemaFacto.getDynamicSchemaFacade(AppTokenService.PAGE_SCHEMA_NAME),
          translateService,
          AppTokenService.PAGE_SCHEMA_NAME + '-facade'
          );
    }

}
